import { useState } from "react";
import { CustoFuncionarioInputCard } from "./components/CustoFuncionarioInputCard";
import { CustoFuncionarioResponse } from "./components/CustoFuncionarioResponse";
import type { CustoFuncionarioResultsType } from "./calculadora-custo-funcionario";

export default function CalculadoraCustoFuncionarioCLT() {
  const [results, setResults] = useState<CustoFuncionarioResultsType | null>(null);

  return (
    <>
      <CustoFuncionarioInputCard setResults={setResults} />
      {results && <CustoFuncionarioResponse results={results} />}
    </>
  );
}